import { useAtom } from "jotai";
import Axios from "axios";
import { environment } from "../../environment";
import { errorCatcher } from "../../hooks";
import { useLogin } from "../login";
import {
    IOrderFulfillmentStatus,
    orderFulfillmentStatusesAtom,
    orderFulfillmentStatusesLoadingAtom,
} from "./types";

type UseOrderFulfillmentStatuses = [
    IOrderFulfillmentStatus[],
    boolean,
    { get: () => void }
];

export const useOrderFulfillmentStatuses = (): UseOrderFulfillmentStatuses => {
    const [statuses, setStatuses] = useAtom(orderFulfillmentStatusesAtom);
    const [loading, setLoading] = useAtom(orderFulfillmentStatusesLoadingAtom);
    const [, authToken, loginFunctions] = useLogin();

    const getOrderFulfillmentStatuses = () => {
        const fetch = async (): Promise<void> => {
            setLoading(true);
            const results = await Axios.get(environment.orderFulfillmentStatusesUrl, {
                headers: {
                    "X-Wallmates-Auth": authToken,
                },
            }).catch((err: any) => errorCatcher(err, loginFunctions.logout));
            if (results) {
                setStatuses(results.data);
            }
            setLoading(false);
        };

        fetch();
    };

    return [statuses, loading, { get: getOrderFulfillmentStatuses }];
};
